export const ValidationPatterns = {
    //301193 - email validation updated
    //Version 1 - Email = "^[\\w-.]+@[\\w-.]+\\.[\\w-]{2,4}$",
    //Version 2 - Email = String.raw`(?:[a-zA-Z0-9!#$%&'*+/=?^_${"`"}{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_${"`"}{|}~-]+)*|\"
    //            (?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*\")@(?:(?:[a-zA-Z0-9]
    //            (?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])
    //            |1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:
    //            (?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])`
    email: getEmailPattern(),
    phone: "(\\+?\\d[- .]*){7,13}",
    floatNumber: "^-?(0|[1-9]\\d*)(\\.\\d+)?$",
    notEmpty: "^(?!\\s+$).+",
    uri: "^[A-Za-z0-9\\._~:\\/\\?#\\[\\]@!\\$&'\\(\\)\\*\\+\\-,;=]*$" /* https://datatracker.ietf.org/doc/html/rfc3986/ */,
    username: "^[a-zA-Z0-9-._@+]+$",
    srxWebhookSecret: "^whsec_[a-f0-9]{40}$"
};

// Validation pattern for an email.
function getEmailPattern(): string {
    // Validation pattern for the local address of the email (the section before the @).
    const emailLocalAddressPattern: string = getEmailLocalAddressPattern();

    // Validation pattern for the domain address of the email (the section after the @).
    const emailDomainAddressPattern: string = getEmailDomainAddressPattern();

    // Validation pattern for the whole email.
    return `${emailLocalAddressPattern}@${emailDomainAddressPattern}`;
}

// Validation pattern for the local address of the email (the section before the @).
function getEmailLocalAddressPattern(): string {
    const nonPrintableCharacterPattern: string = getNonPrintableCharacterPattern(true);

    // Validation pattern for the username section of the email (the section of the email commonly before the first dot).
    const emailUserNamePattern: string = "[a-zA-Z0-9!#$%&'*+/=?^_\"\`{|}~-]+";

    // Validation pattern for the alias section of the email (the section of the email commonly after the first dot).
    const emailLocalAliasPattern: string = `(?:\\.${emailUserNamePattern})*|\\"(?:${nonPrintableCharacterPattern})*\\"`;

    // Validation pattern for the local address of the email (the section before the @).
    return `(?:${emailUserNamePattern}${emailLocalAliasPattern})`;
}

// Validation pattern for the domain address of the email (the section after the @).
function getEmailDomainAddressPattern(): string {
    const commonEmailDomainAddressPattern: string = getEmailCommonDomainAddressPattern();
    const ipBasedEmailDomainAddressPattern: string = getEmailIpBasedDomainAddressPattern();

    return `(?:${commonEmailDomainAddressPattern}|${ipBasedEmailDomainAddressPattern})`
}

// Validation pattern for the common domain address of an email.
function getEmailCommonDomainAddressPattern(): string {
    const alphanumericPattern: string = "[a-zA-Z0-9]";
    const alphanumericNotEndedInHyphensPattern: string = getAlphaNumericNotEndedInHyphensPattern();

    // Validation pattern for the domain name sections (the sections between dots in the email domain address).
    // TODO: Check this pattern:
    //  - It builds [a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9-])?
    //  - I'm almost sure it is reducible to [a-zA-Z0-9]+(?:-+[a-zA-Z0-9]+)*
    const domainSectionPattern: string = `${alphanumericPattern}(?:${alphanumericNotEndedInHyphensPattern})?`;

    return `(?:${domainSectionPattern}\\.)+${domainSectionPattern}`;
}

// Validation pattern for the IP based domain address of an email.
function getEmailIpBasedDomainAddressPattern(): string {
    const nonPrintableCharacterPattern: string = getNonPrintableCharacterPattern(false);
    const alphanumericNotEndedInHyphensPattern: string = getAlphaNumericNotEndedInHyphensPattern();

    // Validation pattern for IP sections (the sections between dots in an IP address).
    const ipAddressSectionPattern: string = "(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])";

    // Validation pattern for IP based domain address suffix that supports identifiers (like protocol or service identifiers).
    const ipBasedAddressIdentifierSuffix: string = `${alphanumericNotEndedInHyphensPattern}:(?:${nonPrintableCharacterPattern})+`;

    // Validation pattern for IP prefix (the first three sections of an IP, for example 127.0.0).
    const ipBasedAddressPrefixPattern: string = `(?:(?:${ipAddressSectionPattern})\\.){3}`;

    // Validation pattern for IP based domain address suffix (the last section of an IP or a section that specifies protocol or service identifier).
    const ipBasedAddressSuffixPattern: string = `${ipAddressSectionPattern}|${ipBasedAddressIdentifierSuffix}`;

    return `\\[${ipBasedAddressPrefixPattern}(?:${ipBasedAddressSuffixPattern})\\]`;
}

// Validation pattern for alphanumeric with hyphens sections.
function getAlphaNumericNotEndedInHyphensPattern(): string {
    const alphanumericPattern: string = "[a-zA-Z0-9]";
    const alphanumericWhitHyphensPattern: string = "[a-zA-Z0-9-]";
    return `${alphanumericWhitHyphensPattern}*${alphanumericPattern}`;
}

// Validation pattern for sections of the email that allows non-printable and control characters.
function getNonPrintableCharacterPattern(forLocalAddress: boolean): string {
    const escapedNonPrintableCharacterPattern: string = "\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f]";
    const unescapedNonPrintableCharacterPatternForLocalAddress: string = "[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]";
    const unescapedNonPrintableCharacterPatternForDomainAddress: string = "[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]";

    const unescapedNonPrintableCharacterPattern: string = forLocalAddress
        ? unescapedNonPrintableCharacterPatternForLocalAddress
        : unescapedNonPrintableCharacterPatternForDomainAddress;

    return `${unescapedNonPrintableCharacterPattern}|${escapedNonPrintableCharacterPattern}`;
}